import PropTypes from 'prop-types'
import React from 'react'

export default function FormFooter({ children }: props) {
  return (
    <footer className="FormFooter uk-grid-margin">
      {children}
    </footer>
  )
}

FormFooter.propTypes = {
  children: PropTypes.node.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/FormFooter/FormFooter.js